import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../api";
import { getReceiptPrintExtras, openReceiptWindow } from "../receiptPrinting";

export default function Receipt() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const openedRef = useRef(false);

  useEffect(() => {
    let active = true;

    (async () => {
      try {
        const res = await api.get(`/chek/${id}/`);
        if (!active) return;
        setData(res.data);
        document.title = `Chek ${res.data?.check_no || id}`;
      } catch (err) {
        console.log("Receipt load error", err?.response?.status, err?.response?.data);
        if (active) setError("Chekni yuklab bo'lmadi.");
      }
    })();

    return () => {
      active = false;
    };
  }, [id]);

  useEffect(() => {
    if (!data || openedRef.current) return;
    openedRef.current = true;
    openReceiptWindow(data, getReceiptPrintExtras(data));
  }, [data]);

  if (error) {
    return (
      <div style={{ padding: 24 }}>
        <h2>Chek topilmadi</h2>
        <p>{error}</p>
        <button onClick={() => window.history.back()} type="button">
          Orqaga
        </button>
      </div>
    );
  }

  if (!data) {
    return <div style={{ padding: 24 }}>Chek yuklanmoqda...</div>;
  }

  return (
    <div style={{ padding: 24, display: "grid", gap: 12 }}>
      <h2 style={{ margin: 0 }}>Chek #{data.check_no || data.id}</h2>
      <p style={{ margin: 0, color: "#666" }}>
        Chek bir xil formatda yangi oynada ochiladi. Agar brauzer popupni bloklasa, pastdagi tugmani bosing.
      </p>
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        <button onClick={() => openReceiptWindow(data, getReceiptPrintExtras(data))} type="button">
          Chekni ochish
        </button>
        <button onClick={() => window.history.back()} type="button">
          Orqaga
        </button>
      </div>
    </div>
  );
}
